export default {
    it: {
        
    },
    en: {
        
    }
}